export default {
    it: {
        
    },
    en: {
        
    }
}